export interface ValidateTokenResponse {
  message: string
  data: {
    email: string
    is_personal_account: boolean
  }
}

export interface ValidateTokenRequest {
  token: string
}
